import styles from './styles.module.scss'

interface ViewClientDataProps {
    success: boolean
    url: string
}

export const ClientCreatedResultModalContent = ({ success, url }: ViewClientDataProps) => {
    return (
        <div className={styles.resultModalContainer}>
            {success ? (
                <div className={styles.successContent}>
                    <div className={styles.iconContainer}>
                        <div className={styles.successIcon}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </div>

                    <h2 className={styles.title}>Client Created Successfully</h2>
                    <p className={styles.message}>
                        Your client has been successfully created and is ready for the next steps.
                    </p>

                    <div className={styles.linkSection}>
                        <h3 className={styles.linkTitle}>E-Signature Link</h3>
                        <p className={styles.linkDescription}>
                            Share this link with your client to complete the e-signature process:
                        </p>
                        <div className={styles.linkContainer}>
                            <a href={url} target="_blank" rel="noopener noreferrer" className={styles.link}>
                                <span className={styles.linkText}>{url}</span>
                                <svg
                                    className={styles.externalIcon}
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M18 13V19A2 2 0 0 1 16 21H5A2 2 0 0 1 3 19V8A2 2 0 0 1 5 6H11M15 3H21V9M10 14L21 3"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={styles.errorContent}>
                    <div className={styles.iconContainer}>
                        <div className={styles.errorIcon}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 14L12 12L14 14M12 12L14 10L12 8M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </div>

                    <h2 className={styles.title}>Client Creation Failed</h2>
                    <p className={styles.message}>
                        We encountered an issue while creating your client. Please try again or contact support if the
                        problem persists.
                    </p>

                    <div className={styles.errorActions}>
                        <button className={styles.retryButton}>
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1 4V10H7M23 20V14H17M20.49 9A9 9 0 0 0 5.64 5.64L1 10M3 14L7.64 18.36A9 9 0 0 0 20.49 15"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            Try Again
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
